import { render, staticRenderFns } from "./Quattro.vue?vue&type=template&id=15129c0c&"
import script from "./Quattro.vue?vue&type=script&lang=ts&"
export * from "./Quattro.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15129c0c')) {
      api.createRecord('15129c0c', component.options)
    } else {
      api.reload('15129c0c', component.options)
    }
    module.hot.accept("./Quattro.vue?vue&type=template&id=15129c0c&", function () {
      api.rerender('15129c0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Quattro.vue"
export default component.exports